/**
 * Service Worker Registration
 * 
 * In production: registers the service worker for offline support
 * In development: unregisters any existing service workers to prevent stale bundles and HMR issues
 */

export function ensureServiceWorkerRegistered() {
  if (import.meta.env.PROD) {
    // PRODUCTION: Register service worker
    if ('serviceWorker' in navigator) {
      window.addEventListener('load', () => {
        navigator.serviceWorker
          .register('/custom-sw.js')
          .then(reg => {
            console.log('[SW] registered:', reg.scope);
          })
          .catch(err => console.warn('[SW] registration failed', err));
      });
    }
  } else {
    // DEVELOPMENT: Remove any existing service workers to avoid stale bundles
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker
        .getRegistrations()
        .then(regs => {
          regs.forEach(reg =>
            reg.unregister().then(() => console.log('[DEV] unregistered sw', reg.scope))
          );
        })
        .catch(e => console.warn('[DEV] sw unregister fail', e));
    }
  }
}
